import axios from "axios";
import { LANGUAGE_VERSIONS } from "./constants";

const API = axios.create({
  baseURL: "https://emkc.org/api/v2/piston",
});
const getRuntimes = async () => {
  const response = await API.get("/runtimes");
  return response.data;
};

export const executeCode = async (language, sourceCode) => {
  const supportedLanguages = await getRuntimes();
  const languageSupported = supportedLanguages.some(
    (lang) => lang.language === language && lang.version === LANGUAGE_VERSIONS[language]
  );

  if (!languageSupported) {
    throw new Error(`Language ${language} is not supported.`);
  }

  const response = await API.post("/execute", {
    language: language,
    version: LANGUAGE_VERSIONS[language],
    files: [
      {
        content: sourceCode,
      },
    ],
  });
  
  return response.data;
};
